import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { CloudApiService } from './cloud-api.service';
import { environment } from '../../../environments/environment';
import { BacnetDiscoveryResponse, BacnetStatusResponse } from 'src/api/bacnet';

/** Shape returned by GET /api/devices/{id}/bacnet. */
export interface CloudBacnetResponse {
    status: BacnetStatusResponse;
    discovery: BacnetDiscoveryResponse;
}

/**
 * Cloud mode adapter for BACnet status.
 *
 * Reads through the DeviceRegistry.Api endpoint, which relays to the processor over the WebSocket
 * tunnel — BACnet state is not stored in the cloud, so this is always a live read.
 *
 * Read-only: starting a discovery or installing a licence is only available from the dashboard
 * running on the processor itself.
 */
@Injectable()
export class CloudBacnetService {
    private http = inject(HttpClient);
    private cloudApi = inject(CloudApiService);

    async fetch(deviceId: string): Promise<CloudBacnetResponse> {
        const token = this.cloudApi.token();
        let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        if (token) headers = headers.set('Authorization', `Bearer ${token}`);

        return firstValueFrom(this.http.get<CloudBacnetResponse>(`${environment.apiBaseUrl}/devices/${deviceId}/bacnet`, { headers }));
    }
}
